module.exports = __webpack_public_path__ + "media/images/dividend/ill-success-left-6b4c7364ae68cc73cd84a056f3c75a1e.svg";